import { PlayCircleOutline } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useResumeRequest } from '../../pause-modal/useResumeRequest'

interface Props {
  requestId: string
  onClose?: () => void
}

export const ResumeMenuItem = ({ requestId, onClose }: Props) => {
  const { t } = useTranslation('requests')

  const { mutate: resumeRequest } = useResumeRequest({ requestId })

  return (
    <MenuItem
      onClick={() => {
        resumeRequest()
        onClose?.()
      }}
    >
      <ListItemIcon>
        <PlayCircleOutline />
      </ListItemIcon>
      <ListItemText>{t('manage-request.resume')}</ListItemText>
    </MenuItem>
  )
}
